import { render } from "./priceDetails.vue?vue&type=template&id=73675381&scoped=true"
import script from "./priceDetails.vue?vue&type=script&lang=js"
export * from "./priceDetails.vue?vue&type=script&lang=js"

import "./priceDetails.vue?vue&type=style&index=0&id=73675381&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73675381"]])

export default __exports__